import { render } from "./AdministrationHeader.vue?vue&type=template&id=5afcc490"
import script from "./AdministrationHeader.vue?vue&type=script&lang=js"
export * from "./AdministrationHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__